export default "__VITE_ASSET__VhpbXDo4__"